
<template>
  <el-container class="errorIndex">
        <full-calendar :events="events" v-loading="loading"
        ref="calendar"
        :config="config">
        <template v-slot:eventContent='arg'>
          <p><span></span></p>
            <p>{{ arg.timeText }}</p>
            <p>{{ arg.event.extendedProps.title_1 }}</p>
            <p>{{ arg.event.title }}</p>
          </template>
          </full-calendar>
  </el-container>
</template>
<script>
import IndexHeader from './views/header'
export default {
  components: {
    IndexHeader
  },
  data(){
    return {
      events: [],
      config: {
         header:{
            left: 'prev,next today',
            center: 'title',
            right: 'month,agendaWeek,agendaDay,list'
          },
          buttonText: { today: "Today", month: "Month", week: "Week", day: "Day" },
          locale: "en",
          height:'auto',//设置日历的高度，包括header日历头部，默认未设置，高度根据aspectRatio值自适应。
          defaultView: "month", //显示默认视图
          //contentHeight://设置日历主体内容的高度，不包括header部分，默认未设置，高度根据aspectRatio值自适应。
          aspectRatio:1.35,//设置日历单元格宽度与高度的比例。
          //weekMode: 'liquid',
          // weekNumbers: true,
          slotEventOverlap : true,
          timeFormat: 'HH:mm',
          navLinks: true,       // can click day/week names to navigate views
          eventLimit: 3,        // 限制一天中显示的事件数，默认false
          allDaySlot:false,
          // allDayText: '排班',   // 日历上显示全天的文本
          editable: false,
          selectable: false,     // 允许用户通过单击或拖动选择日历中的对象，包括天和时间。
          selectHelper: true,  // 当点击或拖动选择时间时，显示默认加载的提示信息，该属性只在周/天视图里可用。
          unselectAuto: true,   // 当点击页面日历以外的位置时，自动取消当前的选中状态。
          eventBackgroundColor: '#EFF6FF',    // 设置日程事件的背景色
          select: this.selectHandler,
          eventClick:this.eventClick,
          eventRender : function(event, element, view) {          //当Event对象开始渲染时触发
              console.log("eventRender():"+event.title);
              if(view.type=="month"){
                element.html(event.time+'<br><i>'+event.title+'</i><br><i>'+event.level_title+'</i>');
              }else if(view.type=="agendaWeek"){
                element.html('<i>'+event.time+event.title+event.level_title+'</i>');
              }else if(view.type=="agendaDay"){
                element.html(event.time+'&nbsp;&nbsp;'+event.title+'&nbsp;&nbsp;'+event.level_title);
              }else if(view.type=="list"){
                element.html('<td class="fc-list-item-time fc-widget-content">'+event.time+'</td>'+
                '<td class="fc-list-item-marker fc-widget-content"><span class="fc-event-dot" style="background-color:#EFF6FF"></span></td>'+
                '<td class="fc-list-item-title fc-widget-content"><a>'+event.title+'</a>&nbsp;&nbsp;&nbsp;&nbsp;<a>'+event.level_title+'</a></td>');
              }
          },
       },
       loading:false,
    }
  },
  created () {
    if (!this.utils.getCookie('pc_token')) {
      this.$router.push({
        path: '/'
      })
      return false
    }
    this.changeMonth()
  },
  methods:{

    changeMonth(start, end, current){
      this.loading = true
      // console.log('changeMonth', start.format(), end.format(), current.format())
      this.$http.get('/tutor/api/getTeacherCalendar?date_type=1').then(res=>{
            res.data.data.lesson_data.forEach((item,i)=>{
                this.events.push({
                    id: i,
                    title:item.subject_title+' - '+item.progress,
                    start:item.start_at,
                    time:item.time,
                    level_title:item.level_title
                })
                if(i==res.data.data.lesson_data.length-1){
                    this.loading = false
                }
            })
        })
    },
  }
}
</script>
<style lang="less" scoped>
  .errorIndex{
    height: 100%;
    .el-header{
    height: 88px!important;
      background: rgba(53,54,67,0.90);
      width: 100%;
      padding:0;
    }

  }
/deep/ .fc{

    max-width: 1100px;
    margin: 30px auto;
  font-family: Arial;



  /* 按钮样式 */
  .fc-state-default{
      width:70px;
      margin:0 10px;
      background: #fff;
      color:#353643;
      border:none;
      border-radius: 10px!important;
      outline: none;

  }
  .fc-event{
    bottom: initial!important;
    i{
      font-weight: normal;
      font-size: 12px;
    }
  }
  /* 按钮选中的样式 */
  .fc-toolbar .fc-state-active,
  .fc-toolbar .fc-state-active:hover{
      background: #ff6440;
      color:#fff;
      border:none;

  }
  /* 取消待办事项的默认样式 */
  .fc-event, .fc-event-dot{
      background: none;
      color:#000;
      font-size:14px;
  }
  /* 文字颜色 */
  .fc-event, .fc-event:hover,.fc-v-event .fc-event-main,
  .fc-h-event .fc-event-main{
      color:#000;
  }


  td.fc-today{
      background: #EFF6FF;
  }
  .fc-event{
      border:none;
  }
  /* 高速自适应没生效 */
  .fc .fc-timegrid-slot{
      height:auto;
  }
  /* 让上方的按钮显示在同一行 */
  .fc .fc-toolbar > * > :first-child{
      display: flex;
  }


  /* 显示的问题设置 */
  p span{
      width: 11px;
      height: 10px;
      background: #CACCED;
      border-radius: 7px;
      display: inline-block;
  }
      i{
          font-style: normal;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/calendar.vue